/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 14/2/2022
 */

import BaseIdObject from "@shared/BaseIdObject";
import WorkflowEntryItem from "@shared/Workflow/base/WorkflowEntryItem";

export default class WorkflowStageItem extends BaseIdObject {

	workflowId: string = null
	states: string[] = []
	title: string = null
	tooltip: string = null
	stageViewName: string = null

	emptyView = null

	triggers: string[] = [] // triggers that this stage responds to. Ex, move to this stage when client signed a contract


	_loadedEntries = []
	_hasMore = true

	constructor(title: string = null, options = {}) {
		super();
		this.states = options.states || [];
		this.title = title;
		this.label = title; //deprecated field
		this.tooltip = options.tooltip || null
		this.stageViewName = options.stageViewName || null
		this.emptyView = options.emptyView || null
	}

	setTriggers(triggers){
		this.triggers = triggers
	}

	getStatesPrefixed(){
		return this.states
	}

	createEntryItem(){
		let entry = new WorkflowEntryItem()
		entry.stageId = this.id
		entry.addWorkflowId(this.workflowId)
		return entry
	}
}
